import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FormDataRequestObject } from '../../../../../types';
import { handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { postCreateApplicationDoc } from '../../requests/postCreateApplicationDoc';

export const useCreateApplicationDoc = (definitionName: string) => {
  const queryClient = useQueryClient();
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: createDoc, ...rest } = useMutation({
    mutationFn: ({
      uuid,
      data,
    }: {
      uuid: string;
      data: FormDataRequestObject<any>;
    }) => postCreateApplicationDoc(constructPost, uuid, definitionName, data),
    onSuccess: (_, { uuid }) => {
      handleSuccess('Success');
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, uuid, 'docs'],
      });
    },
  });

  return { createDoc, ...rest };
};
